//Load cart object data
    function cartProcess() {
    theme.cart.getCart().then((cartData => {
      const freeShipEnabled = true;
      const freeGiftEnabled = false;
      const upsellEnabled = true;
      
      if (freeShipEnabled){
        freeShipping(cartData);
      }

      if (freeGiftEnabled || upsellEnabled){
        cartSkus(cartData);
      };
      
    }))
  }
  
  //Listen for 'cart build'
   document.addEventListener('cart:updated', function(evt){
     cartProcess();
  });
  
  //Listen for 'cart build'
   document.addEventListener('ajaxProduct:added', function(evt){
     cartProcess();
  });
  
  //Listen for 'cart build'
   document.addEventListener('DOMContentLoaded', function(evt){
    cartProcess();
  });

  //Listen for 'cart build'
   document.addEventListener('cart:build', function(evt){
    cartProcess();
    });
  
  //Cart Free Shipping Script

  // Update free gift progress bar + free gift messaging
  // Update for Ajax drawer cart
  // Ensure subscription variantId is passed to cart
  function freeShipping(data){
    let cartTotal = data.total_price;
    let cartitems = data.items;
    let subscriptionplan = cartitems.filter(element => element.selling_plan_allocation);
    let freeshippingamount = 200 * 100;
    let fselement = document.getElementById("shipping-text");
    let shiptotal = document.getElementById("shippingcost");
    let progressbar = document.querySelector(".ship_progressbar");
    let shipcontainer = document.getElementById("free-shipping-container");
    
    if (freeshippingamount < cartTotal || subscriptionplan.length != 0){
      fselement.innerHTML = "You scored <b>Free Shipping!</b>";
      shiptotal.innerHTML = "FREE";
      progressbar.style.width = 100 + "%";
      progressbar.style.backgroundColor = "#53c563";
    } else {
      let pricediff = ((freeshippingamount - cartTotal)/100).toFixed(2);
      let variance = (cartTotal/freeshippingamount) * 100;
      fselement.innerHTML = "You're " + "$" + pricediff + " away from <b>Free HK Shipping</b>";
      shiptotal.innerHTML = "$30.00";
      progressbar.style.width = variance + "%";
      progressbar.style.backgroundColor = "#d22137";
    }
  }
 
  // Hide elements based on cart contents
  function cartSkus(data){
    const freeGiftEnabled = false;
    const upsellEnabled = true;
    let freeGiftPrompt = document.querySelector(".noclick");
    let claimFreeGift = document.querySelector(".clicktoclaim");
    let freeGiftClaimed = document.querySelector(".giftclaimed");
    let upsellcontainer = document.getElementById("upsell-container");
    let cartTotal = data.total_price;
    let freegiftamount = 0 * 100;
    let cartitems = data.items;
    let cartskus = cartitems.map(element => element.sku);
    let cartdiscounts = cartitems.map(element => element.line_level_total_discount);
    let discountval = [1400];
    let upsellskus = ['4385'];
    
    function checkContents(arr1, arr2){
    	return arr1.some(item => arr2.includes(item))
    }

    if(freeGiftEnabled){
        if(cartTotal < freegiftamount){
        	freeGiftPrompt.classList.remove("hide");
            claimFreeGift.classList.add("hide");
            freeGiftClaimed.classList.add("hide");
        } else if(checkContents(cartdiscounts, discountval)){
        	freeGiftPrompt.classList.add("hide");
            claimFreeGift.classList.add("hide");
            freeGiftClaimed.classList.remove("hide");
        } else {
        	freeGiftPrompt.classList.add("hide");
            claimFreeGift.classList.remove("hide");
            freeGiftClaimed.classList.add("hide");
        }
      }

  if(checkContents(cartskus, upsellskus)){
      upsellcontainer.classList.add("hide");
      console.log(cartitems);
    } else {
      upsellcontainer.classList.remove("hide");
    }
  }
  
  // Add to cart button
	function addToCart(variant, freeGiftClass) {
    fetch('/cart/add.js', {
        body: JSON.stringify({
            'id': variant, 
            'quantity': 1
        }),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
    }).then(function (response) {
        return response.json();
    }).then(function (json) {
      
    document.dispatchEvent(new CustomEvent('cart:build'));

    }).catch(function (err) {
        console.error(err)
    });
	}